<script setup lang="ts">
import Dashboard from "@/views/playground/planner/dashboard/Dashboard.vue";
</script>

<template>
  <dashboard></dashboard>
</template>

<style scoped></style>
